import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';

export type RestaurantSegmentOption = components['schemas']['RestaurantSegmentOption'];

const REQUEST_TYPE: keyof typeof apiConfig = 'get restaurant segment options';
const DEFAULT_DATA: RestaurantSegmentOption[] = [];

async function getRestaurantSegmentOptions(): Promise<RestaurantSegmentOption[]> {
    return http.get(REQUEST_TYPE, {});
}

export function useRestaurantSegmentOptions() {
    return useData(DEFAULT_DATA, getRestaurantSegmentOptions);
}
